import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/kielo";
import { useApp } from "@/context/AppContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSession } = useApp();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", "/dashboard");
        await setSession(data);
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/", { replace: true }), 2000);
      }
    };
    run();
  }, [location.hash, navigate, setSession]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F9F8F5]" data-testid="auth-callback">
      <div className="w-10 h-10 rounded-full border-2 border-[#0E382B] border-t-transparent animate-spin" />
      <p className="mt-5 text-[#52635B] font-serif text-lg">
        {error ? "Kirjautuminen epäonnistui. Palataan…" : "Kirjaudutaan sisään…"}
      </p>
    </div>
  );
}
